import React from "react";
import { Logo } from "./Logo";
import { Instagram, Mail } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#FAF9F6] border-t border-[#E8E3DD]">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 md:py-20">
      <div
        data-testid="footer-mark"
        className="font-display text-7xl sm:text-8xl md:text-[10rem] leading-none text-[#2C1E16] tracking-tight flex items-center justify-start gap-2"
      >
        <span>M</span>
        <svg viewBox="0 0 24 24" className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24" fill="#D4A373" aria-hidden="true">
          <path d="M12 21s-7.5-4.7-9.6-9.2C.7 7.9 3.2 4 7.1 4c2 0 3.6 1.1 4.9 2.8C13.3 5.1 14.9 4 16.9 4c3.9 0 6.4 3.9 4.7 7.8C19.5 16.3 12 21 12 21z" />
        </svg>
        <span>C</span>
      </div>

      <div className="mt-10 grid md:grid-cols-12 gap-8 md:gap-12 border-t border-[#E8E3DD] pt-10">
        <div className="md:col-span-5">
          <Logo testId="footer-logo" />
          <p className="mt-4 text-[#5C4E46] max-w-md leading-relaxed">
            Bottled here. Shared with the city we love.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.18em] text-[#8D99AE] mb-3">Explore</div>
          <ul className="space-y-2 text-[#2C1E16]">
            <li><a data-testid="footer-link-lattes" href="#lattes" className="hover:text-[#5C4E46]">Lattes</a></li>
            <li><a data-testid="footer-link-about" href="#about" className="hover:text-[#5C4E46]">About</a></li>
            <li><a data-testid="footer-link-popups" href="#popups" className="hover:text-[#5C4E46]">Pop-ups</a></li>
            <li><a data-testid="footer-link-contact" href="#contact" className="hover:text-[#5C4E46]">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.18em] text-[#8D99AE] mb-3">Say hello</div>
          <div className="flex flex-col gap-3">
            <a
              data-testid="footer-email"
              href="#"
              className="inline-flex items-center gap-2 text-[#2C1E16] hover:text-[#5C4E46] transition-colors"
            >
              <Mail size={16} strokeWidth={1.5} />
              hello@memphiscoffee.co
            </a>
            <a
              data-testid="footer-instagram"
              href="#"
              className="inline-flex items-center gap-2 text-[#2C1E16] hover:text-[#5C4E46] transition-colors"
            >
              <Instagram size={16} strokeWidth={1.5} />
              @memphiscoffeeco
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-[#E8E3DD] flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-sm text-[#8D99AE]">
        <span data-testid="footer-copyright">© 2026 Memphis Coffee Co.</span>
        <span>Made with care in Memphis, TN.</span>
      </div>
    </div>
  </footer>
);
